import { inject, Injectable } from '@angular/core';
import { ConfigBaseFilter, ConfigService, ListLayout, ListLayoutMultipleComponent, ListSortOption } from 'gung-list';
import { Observable } from 'rxjs';
import { SepaMandatesListViewComponent } from '../../components/sepa-mandates-list-view/sepa-mandates-list-view.component';
import { SepaMandate } from '../../models/sepa-mandates';
import { SepaMandatesService } from '../sepa-mandates/sepa-mandates.service';

@Injectable({
  providedIn: 'root'
})
export class SepaMandatesListConfigService implements ConfigService<SepaMandate> {
  protected sepaMandatesService = inject(SepaMandatesService);

  getLayouts(): ListLayout<SepaMandate>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => SepaMandatesListViewComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'SepaMandatesTable'
      }
    ];
  }

  getItems(): Observable<SepaMandate[]> {
    return this.sepaMandatesService.getAllSepaMandates();
  }

  getFilters(): ConfigBaseFilter<SepaMandate>[] {
    return [];
  }

  getSortOptions(): ListSortOption<SepaMandate>[] {
    return [];
  }

  getBatchSizes(): number[] {
    return [24];
  }
  
  getSearchTerms(item: SepaMandate): string[] {
    return [item.id];
  }

  getItemId(item: SepaMandate): string {
    return item.id;
  }
}
